<template>
      <div class="page-inner">
        <breadcrumb title="General"></breadcrumb>
        <div class="card card-fluid">
          <!-- .card-body -->
          <div class="card-body">
            <div class="tab-content py-3">
              <div class="tab-pane fade" :class="{ 'active show': isActive('employee-request') }">
                <div id="data-table-leave-request-request_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <div class="dt-buttons btn-group">
                        <button class="btn btn-success btn-modal" tabindex="0" @click="toInput"
                                data-title="Request">
                          <em class="fa fa-plus"></em> <span>Add</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div id="data-table-leave-request-request_filter" class="dataTables_filter">
                        <label>
                          Search:<input type="search" class="form-control" placeholder=""
                                        aria-controls="data-table-leave-request-request">
                        </label>
                      </div>
                    </div>
                  </div>

                  <b-table hover :items="items" :fields="fields" :sticky-header="stickyHeader"
                           :no-border-collapse="noCollapse" :sort-direction="sortDirection" :sort-by.sync="sortBy"
                           :sort-desc.sync="sortDesc" responsive
                           table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" hover>

                    <template v-slot:cell(action)="row">
                      <a class="btn btn-xs btn-icon btn-secondary btn-modal"
                         @click="info(row.item, row.index, $event.target)" title="[Detail]" data-title="[Detail]">
                        <em class="fa fa-search"></em>
                      </a>
                    </template>
                  </b-table>
                  <div class="row align-items-center">
                    <div class="col-sm-12 col-md-5">
                      <div class="dataTables_info" id="data-table-leave-request-request_info" role="status"
                           aria-live="polite">Showing {{ currentPage }} to {{ perPage }} of {{ rows }} entries
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-7 d-flex justify-content-end">
                      <div class="dataTables_paginate paging_simple_numbers">
                        <b-pagination v-model="currentPage" v-on:input="getData" :per-page="perPage"
                                      :total-rows="rows"></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- /.card-body -->
        </div>
      </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import {BTable, BPagination} from "bootstrap-vue"
export default {
  name: "Employee"
  ,components:{
    BTable,
    Breadcrumb,
    BPagination,
  },
  data(){
    return {
      activeItem:"employee-request",
      noCollapse:false,
      stickyHeader: true,
      sortDirection: 'asc',
      sortBy: '',
      sortDesc: false,
      items:[],
      fields: [
        { key: 'no', sortable: true , thStyle: {maxWidth: '60px', minWidth: '10px'}},
        { key: 'action', sortable: true, thStyle: {maxWidth: '150px', minWidth: '10px'} },
        { key: 'staff_id',label:"Staff ID", sortable: true },
        { key: 'full_name', sortable: true },
        { key: 'contract_status', sortable: true },
        { key: 'position', sortable: true },
        { key: 'duty_station', sortable: true },
      ],
      currentPage:1,
      perPage:20,
      rows:10,
    }
  },
  methods:{
    isActive(itemTabs){
      return this.activeItem === itemTabs
    },
    toInput(){
      this.$router.push({path:"/employee-edit", query:{id:"123"}})
    },
    getData(){

    }
  },
  mounted() {
    this.isActive(this.activeItem)
  }
}
</script>